import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../components/SectionFormContainer'
import DaycareWizardContext from './DaycareWizardContext'
import useDaycareVisit from '../../../hooks/useDaycareVisit'

const MedicineSchedule = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(DaycareWizardContext)
	const { attr, _id: petId, name, subtext = '' } = props // attr = not_present_meds
	const { loading, facility } = useDaycareVisit()

	const title = useMemo(() => `Medications to Bring for ${name}`, [name])

	const handleSelection = useCallback(
		(medId) => {
			const newValues = { ...wizard_state }
			let newMedInNotPresentArray = []
			const medInNotPresent = wizard_state[attr].findIndex((a) => {
				return a === medId
			})

			if (medInNotPresent > -1) {
				newMedInNotPresentArray = newValues[attr].filter((a) => {
					return a !== medId
				})
			} else {
				newMedInNotPresentArray = [...newValues[attr], medId]
			}

			newValues[attr] = newMedInNotPresentArray
			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	const options = useMemo(() => {
		const { not_present_meds, medications } = wizard_state

		const petMeds = medications.filter(({ pet_id, active }) => {
			return pet_id === petId && active !== false
		})

		const o = petMeds.map(({ _id, name, purpose, active }) => {
			const selected =
				not_present_meds.findIndex((a) => {
					return a === _id
				}) === -1

			return {
				title: name,
				description: purpose,
				selected,
				onSelected: () => handleSelection(_id)
			}
		})

		return o
	}, [handleSelection, loading, wizard_state, attr, facility, petId])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			{options.length === 0 ? (
				<p>No medications found for {name}. Click Next</p>
			) : (
				<OptionsMenu options={options} />
			)}
		</SectionFormContainer>
	)
}

export default MedicineSchedule
